
export const getRegiones = (arrayDir) => {
  const regiones = arrayDir ? arrayDir.map((item) => ({ IdRegion: item.IdRegion, DescripcionRegion: item.DescripcionRegion })) : [];
  return regiones;
};

export const getCiudadesComunas = (arrayDir, IdRegion) => {
  const result = {
    listaComunas: [],
    listaCiudades: [],
  };
  const region = arrayDir ? arrayDir.filter((item) => (item.IdRegion === IdRegion)) : result;
  return region.length === 0 ? result :
    {
      listaComunas: region[0].Comunas,
      listaCiudades: region[0].Ciudades,
    };
};

export const getCodigoArea = (codigo) => ["9", `${codigo === "02" ? codigo.replace("0", "") : codigo}`];

export const getCodigoAreaAll = (arrayDir) => {
  const codigoAreaAll = ["9"];
  if (Array.isArray(arrayDir)) {
    arrayDir.forEach((element) => {
      element.Comunas.forEach((item) => {
        const code = item.CodigoArea == "02" ? "2" : item.CodigoArea;
        if (!codigoAreaAll.includes(code)) {
          codigoAreaAll.push(code);
        }
      });
    });
  }
  return codigoAreaAll;
};
